
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const i18n = nuxtApp.$i18n as any
  const locale = i18n.locale
  
  // Create a custom $fetch instance
  const api = $fetch.create({
    baseURL: config.public.apiUrl as string,
    
    async onRequest({ options }) {
      const authStore = useAuthStore()
      if (authStore.token) {
        options.headers.set('Authorization', `Bearer ${authStore.token}`)
      }
      // TODO: add current workspace id to header
      
      options.headers.set('Accept-Language', locale.value)
    },
    
    async onResponseError({ response }) {
      const message = response._data?.message

      switch (response.status) {
        case 401:
          const authStore = useAuthStore()
          authStore.logout()
          navigateTo('/login')
          break
        case 403:
          try {
            const toast = useToast()
            const i18n = nuxtApp.$i18n as any
            toast.error({
              title: message || i18n.t('error.forbiddenTitle'),
              description: i18n.t('error.forbiddenBody'),
            })
          } catch (_) {
            console.error('API Error 403:', message || response.statusText)
          }
          break
        case 400:
        case 404:
        case 500:
          console.error(`API Error ${response.status}:`, message || response.statusText)
          break
      }
    }
  })
  
  return {
    provide: {
      api
    }
  }
})
